export default __webpack_public_path__ + "static/media/Enes.ca14ed5a.jpeg";